routes.$inject = ['$stateProvider'];

export default function routes($stateProvider) {
    $stateProvider
      .state('feedback', {
        url: '/feedback',
        template: require('./index.html'),
        controller: 'FeedbackController',
        controllerAs: 'fb',
        authRequired: true
      });
}



// WEBPACK FOOTER //
// ./src/app/features/feedback/routes.js